<template>
  <div class="play-container">
    <audio v-show="false" id="audio" ref="audio" controls @canplay="getDuration" @timeupdate="updateTime">
      <source :src="fileurl" type="audio/mpeg" />
      您的浏览器不支持音频播放
    </audio>
    <div class="play-card">
      <div class="play-progress">
        <div ref="progress" class="progress" @click="clickProgress" @mouseup="handleMouseup">
          <div ref="currentProgress" class="currentProgress">
            <span ref="circle" class="circle" @mousedown="handleMousedown"></span>
          </div>
        </div>
        <div class="time">
          <span class="startTime">{{ currentDuration }}</span>
          <span class="endTime">{{ duration }}</span>
        </div>
      </div>
      <div class="play-box" @click="handlePauseOrPlay">
        <i :class="paused === true ? 'el-icon-video-play' : 'el-icon-video-pause'" class="dialogAudioPlay"></i>
        <span class="play-text">{{ paused === true ? '唱标': '暂停' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AudioPlayer',

  props: {
    fileurl: {
      type: String,
      default: 'https://img-qn.51miz.com/Audio/2017/02/06/08/20170206081849_A100187_34f7e6b8-thumb.mp3'
    },
  },
  data() {
    return {
      duration: '00:00',
      currentDuration: '00:00',
      audio: '',
      paused: true,
      isMoveIn: false, // 是否在移动中
    }
  },

  computed: {
    ...mapState('reviewHall', ['chantPlay'])
  },

  watch: {
    chantPlay: {
      handler: function(val) {
        if (this.chantPlay) {
          this.paused = false
          this.isMoveIn = false
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // 暂停或播放
    handlePauseOrPlay() {
      this.audio.paused ? this.audio.play() : this.audio.pause()
      this.paused = !this.paused
    },
    // 视频在可以播放时触发
    getDuration() {
      this.duration = this.timeFormat(this.$refs.audio.duration)
      this.audio = this.$refs.audio
    },
    // 将单位为秒的的时间转换成mm:ss的形式
    timeFormat(number) {
      let minute = parseInt(number / 60)
      let second = parseInt(number % 60)
      minute = minute >= 10 ? minute : '0' + minute
      second = second >= 10 ? second : '0' + second
      return minute + ':' + second
    },
    // 进度条发生变化时触发
    updateTime() {
      if (!this.$refs.progress) return
      this.currentDuration = this.timeFormat(this.audio.currentTime)
      // 如果不是正在移动 和 没有暂停播放就执行
      if (!this.isMoveIn || !this.audio.paused) {
        // 设置当前时间
        const MoveX = this.$refs.progress.clientWidth * (this.audio.currentTime / this.audio.duration)
        // 播放时更新距离
        this.$refs.currentProgress.style.width = MoveX + 'px'
        this.$refs.circle.style.left = MoveX - (this.$refs.circle.clientWidth / 2) + 'px'
      }
      // console.log('this.currentDuration', this.currentDuration)
      // console.log('this.duration', this.duration)
      // 播放完毕，暂停播放
      if (this.currentDuration === this.duration) {
        this.audio.pause()
        this.paused = true
      }
      // console.log('正在执行isMoveIn', this.isMoveIn)
      // console.log('正在执行paused', this.audio.paused)
    },
    // 点击进度条更新进度
    clickProgress(e) {
      // 如果不是正在移动 和 没有暂停播放就执行
      if (!this.isMoveIn || !this.audio.paused) {
        this.updateProgress(e.offsetX)
      }
    },
    // 更新进度
    updateProgress(MoveX) {
      // 当前移动的位置 = 当前移动的位置 / 当前进度条的可视长度    //this.$refs.progress.clientWidth 注意一定要拿总长度 否则会拿进度条已经走过的长度
      const clickProgress = (MoveX / this.$refs.progress.clientWidth)
      // 设置播放的时间 = 总时长 * 当前点击的长度
      this.audio.currentTime = this.audio.duration * clickProgress
      // 设置移动的位置
      this.$refs.currentProgress.style.width = MoveX + 'px'
      this.$refs.circle.style.left = MoveX - (this.$refs.circle.clientWidth / 2) + 'px'
    },
    // 鼠标弹起
    handleMouseup() {
      setTimeout(() => {
        this.audio.play()
        this.paused = false
        this.isMoveIn = false
      }, 200)
    },
    // 圆圈按下
    handleMousedown() {
      this.audio.pause()
      this.paused = true
      this.isMoveIn = true
      const progress = this.$refs.progress
      // 进度条 左 边距离页面左边的距离 移动最小值
      const moveMin = progress.offsetParent.offsetLeft + progress.offsetLeft
      // 进度条 右 边距离页面左边的距离 移动最大值
      const moveMax = progress.offsetParent.offsetLeft + progress.offsetLeft + progress.clientWidth
      // 小圆圈的宽度
      const circleWidth = (this.$refs.circle.clientWidth / 2)
      const move = (move) => {
        if (move.pageX >= moveMax) {
          return
        } else if (move.pageX <= moveMin) {
          return
        }
        this.$refs.circle.style.left = move.pageX - moveMin - circleWidth + 'px'
        this.updateProgress(move.pageX - moveMin)
      }
      // 获取当前鼠标的位置 X
      document.addEventListener('mousemove', move)
      // 鼠标弹起来
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', move)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.play-card {
  display: flex;
  .play-progress{
    flex: 1;
  }
  .progress {
    height: 7px;
    border-radius: 3px;
    margin-bottom: 5px;
    background-color: #DADFEA;
    cursor: pointer;
    .currentProgress {
      position: relative;
      height: 100%;
      width: 0;
      background-color: rgb(39, 216, 254);
      border-radius: 3px;
      .circle {
        position: absolute;
        right: -6px;
        top: -2px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: rgb(39, 216, 254);

        &:hover {
          width: 12px;
          height: 12px;
          top: -3px;
          border-radius: 50%;
        }
      }
    }
  }
  .play-box{
    width: 70px;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  .dialogAudioPlay {
    cursor: pointer;
    color: rgb(39, 216, 254);
    font-size: 24px;
  }
  .play-text{
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    color: rgb(39, 216, 254);
  }
  .time {
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 12px;
  }
}
</style>
